<svg 
    [ngClass]="IconClass"
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 14 14">
    <path d="M13.25 3c0.414 0 0.75 0.336 0.75 0.75v9.5c0 0.414-0.336 0.75-0.75 0.75h-7.5c-0.414 0-0.75-0.336-0.75-0.75v-2.25h-4.25c-0.414 0-0.75-0.336-0.75-0.75v-5.25c0-0.414 0.242-0.992 0.531-1.281l3.188-3.188c0.289-0.289 0.867-0.531 1.281-0.531h3.25c0.414 0 0.75 0.336 0.75 0.75v2.563c0.305-0.18 0.695-0.312 1-0.312h3.25zM9 4.664l-2.336 2.336h2.336v-2.336zM4 1.664l-2.336 2.336h2.336v-2.336zM5.531 6.719l2.469-2.469v-3.25h-3v3.25c0 0.414-0.336 0.75-0.75 0.75h-3.25v5h4v-2c0-0.414 0.242-0.992 0.531-1.281zM13 13v-9h-3v3.25c0 0.414-0.336 0.75-0.75 0.75h-3.25v5h7z"></path>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-files-o.html